module.exports = __webpack_public_path__ + "static/media/fs-hero-v2.4c236a07.png";